import { TaskModel } from "models/TaskModel";
import { createContext } from "react";
import { TriggerEvent } from "react-contexify";

export interface TasksContextMenuContextProps {
  showContextMenu: (event: TriggerEvent, item: TaskModel) => void;
}
export const TasksContextMenuContext = createContext({} as TasksContextMenuContextProps);
